module.exports = __webpack_public_path__ + "static/media/support-Suzette_McNaught.047d0438.jpg";